import { useEffect } from 'react';
import { Col, FormGroup, Input } from 'reactstrap';
import { Controller } from 'react-hook-form';
import flightIcon from '../../../assets/images/travel-request/flight.png';
import hotelIcon from '../../../assets/images/travel-request/hotel.png';
import airportIcon from '../../../assets/images/travel-request/airport.png';
import insuranceIcon from '../../../assets/images/travel-request/insurance.png';
import visaIcon from '../../../assets/images/travel-request/visa.png';

const REQUIREMENT_ITEMS = [
  {
    attribute: 'flight',
    name: 'requirements.flight',
    label: 'Flight',
    icon: flightIcon,
  },
  {
    attribute: 'hotel',
    name: 'requirements.hotel',
    label: 'Hotel',
    icon: hotelIcon,
  },
  {
    attribute: 'airport',
    name: 'requirements.airport',
    label: 'Airport Transfer',
    icon: airportIcon,
  },
  {
    attribute: 'insurance',
    name: 'requirements.insurance',
    label: 'Travel Insurance',
    icon: insuranceIcon,
    disabled: true,
  },
  {
    attribute: 'visa',
    name: 'requirements.visa',
    label: 'Visa',
    icon: visaIcon,
    disabled: true,
  },
];

function Requirements({
  isEdit,
  isView = false,
  detailsData,
  control,
  watch,
  setValue,
}) {
  const headerDetails = detailsData?.headerDetails;

  const requirements = watch('requirements');

  useEffect(() => {
    if (isEdit && headerDetails) {
      setValue('requirements', {
        flight: headerDetails?.Flight === 'Y',
        hotel: headerDetails?.Hotel === 'Y',
        airport: headerDetails?.AirportTransfer === 'Y',
        insurance: headerDetails?.TravelInsurance === 'Y',
        visa: headerDetails?.Visa === 'Y',
      });
      return;
    }

    setValue('requirements.insurance', false, {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue('requirements.visa', false, {
      shouldDirty: false,
      shouldValidate: false,
    });
  }, [isEdit, headerDetails, setValue]);

  return (
    <div className="new-travel-request-card p-3 bg-white">
      <div className="fw-semibold mb-2 fs-5">Requirements</div>
      <div className="d-flex flex-row justify-content-between gap-3">
        {REQUIREMENT_ITEMS.map(item => (
          <Col key={item.attribute}>
            <Controller
              name={item.name}
              control={control}
              defaultValue={false}
              render={({ field }) => {
                const isDisabled = Boolean(isView || item.disabled);

                return (
                  <div
                    role="presentation"
                    onClick={() => {
                      if (isDisabled) return;
                      field.onChange(!field.value);
                    }}
                    className={[
                      'ntr-requirements',
                      !isDisabled ? 'clickable-requirement cursor-pointer' : '',
                      isDisabled ? 'ntr-requirements-disabled' : '',
                      requirements?.[item.attribute]
                        ? 'ntr-requirements-selected'
                        : '',
                    ]
                      .filter(Boolean)
                      .join(' ')}
                  >
                    <FormGroup
                      check
                      className="d-flex align-items-center gap-2 mb-0"
                    >
                      <Input
                        type="checkbox"
                        id={item.attribute}
                        className="form-check-input blue-checkbox"
                        name={field.name}
                        checked={!!field.value}
                        onChange={() => {
                          if (!isDisabled) {
                            field.onChange(!field.value);
                          }
                        }}
                        onBlur={field.onBlur}
                        innerRef={field.ref}
                        disabled={isDisabled}
                      />
                      <div className="d-flex align-items-center gap-2">
                        <img src={item.icon} alt={`${item.label} Icon`} />
                        <span className="fw-semibold fs-5">{item.label}</span>
                      </div>
                    </FormGroup>
                  </div>
                );
              }}
            />
          </Col>
        ))}
      </div>
    </div>
  );
}

export default Requirements;
